import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ItemHistoryList from './ItemHistoryList';
import ItemHistoryListService from '../services/ItemHistoryListService';
import PropTypes from 'prop-types';

class ItemHistoryListContainer extends Component {
  static propTypes = {
    itemId: PropTypes.string.isRequired,
  };

  itemHistoryListService = new ItemHistoryListService();
  componentDidMount() {
    this.itemHistoryListService.handleLoad(this.props.itemId);
  }

  render() {
    return (
      <ItemHistoryList
        items={toJS(this.itemHistoryListService.items)}
        fetching={this.itemHistoryListService.fetch.fetching}
      />
    );
  }
}

export default observer(ItemHistoryListContainer);
